import React, { useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';

export const PasswordTestForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    console.log('Test form submitted:', { email, password });
    
    // Test if Chrome recognized the form
    const form = event.target as HTMLFormElement;
    const formData = new FormData(form);
    console.log('Form data:', {
      email: formData.get('email'),
      password: formData.get('password')
    });
    
    alert('Form submitted! Check console for details and see if Chrome prompted to save password.');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 400,
          width: '100%',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          React Password Test
        </Typography>
        
        <form onSubmit={handleSubmit} method="post" autoComplete="on">
          <div style={{ marginBottom: '16px' }}>
            <label htmlFor="test-email" style={{ display: 'block', marginBottom: '4px' }}>
              Email:
            </label>
            <input
              id="test-email"
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                boxSizing: 'border-box'
              }}
            />
          </div>
          
          <div style={{ marginBottom: '16px' }}>
            <label htmlFor="test-password" style={{ display: 'block', marginBottom: '4px' }}>
              Password:
            </label>
            <input
              id="test-password"
              type="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                boxSizing: 'border-box'
              }}
            />
          </div>
          
          <button
            type="submit"
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#619648',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Test Login
          </button>
        </form>
      </Paper>
    </Box>
  );
};
